import { Grid } from "@mui/material";
import React from "react";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import {
  callAPI,
  IRoleMain,
  MasterPages,
  Method
} from "../../commonFunctions/CommonFunctions";
import { Header, IHeaderActions } from "../../Components/Header/Header";
import EstimateModal from "./EstimateModal";
import { resetDataComponent } from "../../StateManagement/actions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import WSLoadingOverlay from "../../Components/WSLoadingOverlay";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import { UpdateStatus } from "../components/UpdateStatus";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import config from '../../Config/clientConfig.json';

const EstimateList: React.FC<any> = React.memo((props) => {
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  // const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);

  const [modalOpen, setModalOpen] = React.useState(false); //for create / update
  const [isPopupOpen, setPopupOpen] = React.useState(false); //for delete;
  const [selectedIdForUpdate, setSelectedIdForUpdate] =
    React.useState<any>(null);
  const [selectedIdForDlt, setSelectedIdForDlt] = React.useState<any>(null);
  const [loading,setLoading] = React.useState(false);
  const [estimateId,setEstimateId] = React.useState(null);

  const source = {
    url: "estimates/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  //edit / delete or perform other actions.
  const handleAction = async(action: string, row: any) => {
    if (action === "Edit") {
      setModalOpen(true);
      setSelectedIdForUpdate(row?._id);
    } else if (action === "Delete") {
      setPopupOpen(true);
      setSelectedIdForDlt(row?._id);
    }else if(action === "Convert To Quotation"){
      try {
      setLoading(true);
      const response: any = await callAPI(`estimates/convert/quotation/${row?._id}`, Method.POST, {});

      console.log("response estimates", response);

      if (response.success) {
        showMessage(response?.message, "success");
        dispatch(resetDataComponent("estimateGrid"));
      }
    } catch (error: any) {
       if (error.message === 'GlobalHandledError') return;
      showMessage(
        error.response?.data.message || "An unexpected error occurred",
        "error"
      );
    } finally {
      setLoading(false);
    }
    }else if(action==="Change Status")
    {
      setEstimateId(row?._id);
    }
  };


  const handleStatus = async (data: any) => {
    try {
      // setLoading(true);
      const response: any = await saveData(data);
      setEstimateId(null);

      if (response && response?.message) {
        dispatch(resetDataComponent("estimateGrid"));
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
      }
    } catch (e: any) {
      showMessage(e.response?.data?.message || "An unexpected error occurred","error");
    } finally {
      setEstimateId(null);
      
    }
  };

  const metadataStatus: IMetaData = {
    title: "Update Status",
    hideActions: false,
    content: (props: any, row: any) => <UpdateStatus {...props} config={config.estimateStatusConfig.staticOptionData}/>,
    actions: [
      {
        label: "Cancel",
        className: "ws-cancel",
        type: "button"
      },
      {
        label: "Submit",
        onClick: handleStatus,
        type: "submit",
        autoFocus: true
      }
    ],
    isDragable: true
  };

  const saveData = async (data: any) => {
    const request: any = {
      status: data?.newStatus,
    };

    const response: any = await callAPI(
      `estimates/update/${estimateId}/status`,
      Method.PATCH,
      request
    );
    console.log("response from status",response);
    return response;
  };

  const handleCloseDialog = (data?: any) => {
    setEstimateId(null);
  };
  
  React.useEffect(() => {
    if (estimateId) {
      openPopUp(metadataStatus, handleStatus, "40rem", handleCloseDialog);
    }
  }, [estimateId]);

  const handleDelete = () => {
    dispatch(resetDataComponent("estimateGrid"));
    showMessage("Estimate deleted successfully!", "success");
  };

  const handleClick = () => {
    setModalOpen(true);
  };

  const handleCreate = async (data: any) => {
    try {
      const method = selectedIdForUpdate ? Method.PUT : Method.POST;
      const url = selectedIdForUpdate
        ? `estimates/update/${selectedIdForUpdate}`
        : "estimates/create";

      const response: any = await callAPI(url, method, data);

      console.log("response estimates", response);

      if (response.success) {
        showMessage(response?.message, "success");
        dispatch(resetDataComponent("estimateGrid"));
      }
    } catch (error: any) {
      if (error.message === 'GlobalHandledError') return;
      showMessage(
        error.response?.data.message || "An unexpected error occurred",
        "error"
      );
    } finally{
    setModalOpen(false);
    }
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const columns: IColumns[] = [
    {
      header: "Customer Name",
      fieldName: "client.name",
      tooltip: true,
      sortable: true
    },

    {
      header: "Title",
      fieldName: "title",
      tooltip: true,
      sortable: true
    },
    {
      header: "Estimation Points",
      fieldName: "estimationPoints",
      tooltip: true,
      sortable: true
    },
    {
      header: "Created Date",
      fieldName: "createdAt",
      tooltip: true,
      type: "date"
    },

    {
      header: "Grand Total",
      fieldName: "total",
      tooltip: true,
      sortable: true
    },

    {
      header: "Status",
      fieldName: "status",
      tooltip: true
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete","Change Status", "Convert To Quotation"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const action: IHeaderActions = {
    type: "button",
    text: "+ New Estimate",
    size: "medium",
    onClick: handleClick,
    variant: "contained",
    color: "primary",
    sx: {
      backgroundColor: "#FF6B2C",
      textTransform: "none",
      "&:hover": { backgroundColor: "#e65c1d" }
    }
  };

  return (
    <>
      <Helmet>
        <title>Estimates | Willsoar Technologies</title>
        <meta
          name="description"
          content="Manage all your estimates in one place. View, add, or edit estimate information easily."
        />
      </Helmet>
      <Grid p={2}>
        <Header
          type="dashboard"
          title="Estimates"
          id={"estimationHeader"}
          action={action}
        />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="estimateGrid"
              columns={columns}
              source={source}
              exportCsv
            />
          </Grid>
        </Grid>

        <EstimateModal
          id={selectedIdForUpdate}
          open={modalOpen}
          onClose={handleClose}
          onCreate={handleCreate}
        />

        {isPopupOpen && (
          <ConfirmationPopup
            apiUrl={"estimates/delete"}
            id={selectedIdForDlt}
            confirmMessage="Are you sure you want to delete this estimate?"
            open={isPopupOpen}
            onClose={() => setPopupOpen(false)}
            onConfirm={handleDelete}
            permanent
          />
        )}
      </Grid>
      <WSLoadingOverlay  loading={loading} />
    </>
  );
});


export default EstimateList;